import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Über uns',
    href: '#about'
  }, {
    name: 'Leistungen',
    href: '#services'
  }, {
    name: 'Vorteile',
    href: '#why-us'
  }, {
    name: 'Prozess',
    href: '#process'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="flex items-center justify-between" data-id="element-74">
          {/* Logo */}
          <a href="#" className="flex items-center group" data-id="element-75">
            <img src="https://cdn.magicpatterns.com/uploads/qTSuk4dVA3ctabyh6N9wY8/IMG_1394.png" alt="KZEV - Kompetenzzentrum für Exzellenz im Vertrieb" className="h-12 sm:h-14 w-auto object-contain transition-opacity group-hover:opacity-80" data-id="element-76" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-77">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-78">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" onClick={() => window.location.href = '#contact'} data-id="element-79">
              Gespräch anfragen
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-80">
            {isMobileMenuOpen ? <X data-id="element-81" /> : <Menu data-id="element-82" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-100 p-4 shadow-lg animate-in slide-in-from-top-5" data-id="element-83">
          <nav className="flex flex-col gap-4" data-id="element-84">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 hover:text-slate-900 py-2 border-b border-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-85">
                {link.name}
              </a>)}
            <Button className="w-full mt-2" onClick={() => {
          window.location.href = '#contact';
          setIsMobileMenuOpen(false);
        }} data-id="element-86">
              Gespräch anfragen
            </Button>
          </nav>
        </div>}
    </header>;
}